<template>
  <form id="market-product-form" @submit.prevent>
    <div class="field">
      <label class="label">
        {{ getQuestionByTag('Q34').title }}
        <b-tooltip :label="getQuestionByTag('Q34').desc"
                   v-if="getQuestionByTag('Q34').desc !== ''"
                   type="is-light"

                   position="is-right" size="is-large" multilined>
          <div class="tooltip-icon">!</div>
        </b-tooltip>
      </label>
      <div class="sep-16"></div>
      <div class="control">
        <falcon-select :multiple="true" :options="countries" vrules="required" vtarget="input[type=hidden]"
                       label="name" v-model="formData['target_customer_locations']" :max="3"></falcon-select>
      </div>
      <div class="help is-danger vrule" rule="required">
        This field is required.
      </div>
    </div>
    <radio-box :question="getQuestionByTag('Q35')"
               v-model="formData['Q35']"></radio-box>
    <radio-box :question="getQuestionByTag('Q36')"
               v-model="formData['Q36']"></radio-box>
    <radio-box :question="getQuestionByTag('Q37')"
               v-model="formData['Q37']"></radio-box>
    <radio-box :question="getQuestionByTag('Q38')"
               v-model="formData['Q38']"></radio-box>
    <radio-box :question="getQuestionByTag('Q39')"
               v-model="formData['Q39']"></radio-box>
    <radio-box :question="getQuestionByTag('Q40')"
               v-model="formData['Q40']"></radio-box>
    <radio-box :question="getQuestionByTag('Q41')"
               @onAnswer="onQ41Answer"
               v-model="formData['Q41']"></radio-box>
    <radio-box :question="getQuestionByTag('Q42')"
               v-model="formData['Q42']" v-if="openQ42"></radio-box>
    <radio-box :question="getQuestionByTag('Q43')"
               v-model="formData['Q43']" @onAnswer="onQ43Answer"></radio-box>

    <div v-if="openQ44To46">
      <radio-box :question="getQuestionByTag('Q44')"
                 v-model="formData['Q44']"></radio-box>
      <radio-box :question="getQuestionByTag('Q45')"
                 v-model="formData['Q45']"></radio-box>
      <radio-box :question="getQuestionByTag('Q46')"
                 v-model="formData['Q46']"></radio-box>
    </div>
    <radio-box :question="getQuestionByTag('Q47')"
               v-model="formData['Q47']"></radio-box>
  </form>
</template>

<script>
import {FormsMixin} from "@/modules/calculator/forms/FormsMixin";
import RadioBox from "@/modules/calculator/components/RadioBox";
import FalconSelect from "@/shared/forms/FalconSelect";
import FounderDetails from "@/modules/calculator/components/FounderDetails";
import {FormValidation} from "@/shared/directives/formValidation";
import {LookupsAPI} from "@/apis/LookupsAPI";

export default {
  name: "MarketProductForm",
  mixins: [FormsMixin],
  components: {RadioBox, FalconSelect,},
  props: {
    questions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    formData: Object
  },
  data() {
    return {
      answers: {},
      numberOfFounders: '',
      countries: [],
      foundersDetails: {},
      formValidation: null
    }
  },
  async mounted() {
    this.formValidation = new FormValidation('#market-product-form');
    this.countries = await LookupsAPI.getCountries();
  },
  methods: {
    getData() {
      let data = this.formatAnswers();
      data['target_customer_locations'] = data['target_customer_locations'].map((item) => item.id)
      return data;
    },
    onQ41Answer(answer, question) {
      if (!this.openQ42) {
        delete this.formData['Q42']
      }
    },
    onQ43Answer(answer, question) {
      if (!this.openQ44To46) {
        delete this.formData['Q44']
        delete this.formData['Q45']
        delete this.formData['Q46']
      }
    }
  },
  computed: {
    openQ42() {
      let title = this.getAnswerTitle('Q41');
      if (!title) return false;
      return title.indexOf('Alpha or Beta') > -1 || title.indexOf('First product') > -1;
    },
    openQ44To46() {
      let title = this.getAnswerTitle('Q43');
      if (!title) return false;
      return title === 'Yes';
    }

  }
}
</script>

<style scoped>

</style>
